import { render, staticRenderFns } from "./PlacementTestTableForm.vue?vue&type=template&id=1bad110a"
import script from "./PlacementTestTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementTestTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports